import React, { useState, useEffect } from "react";
import behandelingenData from "../data/behandelingen.json";

const Prijslijst = () => {
  const [behandelingen, setBehandelingen] = useState([]);

  useEffect(() => {
    setBehandelingen(behandelingenData);
  }, []);

  const handleToggle = (index) => {
    const newBehandelingen = [...behandelingen];
    newBehandelingen[index].isOpen = !newBehandelingen[index].isOpen;
    setBehandelingen(newBehandelingen);
  };

  return (
    <>
      <div className="prijslijst-container">
        <div className="sidebar">
          <div className="sticky-container">
            <div className="sticky-content">
              <div className="sticky-title"></div>
              <ul>
                <li>Pijnloze behandeling</li>
                <li>Lichaamseigen stof</li>
                <li>15 jaar ervaring</li>
                <li>Snel en natuurlijk resultaat</li>
              </ul>
              <p>
                <img
                  src="https://www.queencenter.nl/images/star.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <img
                  src="https://www.queencenter.nl/images/star.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <img
                  src="https://www.queencenter.nl/images/star.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <img
                  src="https://www.queencenter.nl/images/star.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <img
                  src="https://www.queencenter.nl/images/star.png"
                  alt=""
                  width="20"
                  height="20"
                />
                <br /> Wij scoren{" "}
                <a
                  href="https://www.google.com/search?q=queen+center&amp;client=firefox-b-d&amp;source=lnms&amp;sa=X&amp;ved=0ahUKEwjKqoz1-dniAhVKzqYKHVo1ALwQ_AUICygA&amp;biw=1440&amp;bih=733&amp;dpr=2#lrd=0x47c709aeeb9ce9e5:0xdc7d04e5f37e8a4a,1,,,"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  9,8 van 10
                </a>
                <br /> berekend uit 43 reviews.
              </p>
            </div>
          </div>
        </div>
        <div className="prijslijst">
          <div className="hero-content">
            <div className="hero-text">
              <h1>Prijslijst</h1>
              <p>
                Betaling kan contant of met pin. Prijswijzigingen en typefouten
                voorbehouden.
              </p>
              <img
                src="/images/ideal-black.svg"
                alt="iDeal"
                className="ideal"
              />
            </div>
            <img
              src="/images/bg_hero_queencenter.png"
              alt="Hero Background prijslijst"
              className="hero-image"
            />
          </div>
          {behandelingen.map((behandeling, index) => {
            const {
              title,
              price_title_1,
              price_1,
              price_title_2,
              price_2,
              price_title_3,
              price_3,
              price_title_4,
              price_4,
              isOpen
            } = behandeling;

            return (
              <div
                key={index}
                className={`behandeling ${isOpen ? "open" : ""}`}
              >
                <div className="behandeling-title">
                  <h2>{title}</h2>
                  <button
                    className="toggle-button"
                    onClick={() => handleToggle(index)}
                  >
                    {isOpen ? "" : ""}
                    <img
                      src="/images/arrow-down.svg"
                      className="price-icon"
                      alt="Toggle Prices"
                    />
                  </button>
                </div>
                {isOpen && (
                  <div className="behandeling-dropdown">
                    {price_title_1 && price_1 && (
                      <div className="behandeling-price">
                        <p>{price_title_1}</p>
                        <p>
                          <span>{price_1}</span>
                        </p>
                      </div>
                    )}
                    {price_title_2 && price_2 && (
                      <div className="behandeling-price">
                        <p>{price_title_2}</p>
                        <p>
                          <span>{price_2}</span>
                        </p>
                      </div>
                    )}
                    {price_title_3 && price_3 && (
                      <div className="behandeling-price">
                        <p>{price_title_3}</p>
                        <p>
                          <span>{price_3}</span>
                        </p>
                      </div>
                    )}
                    {price_title_4 && price_4 && (
                      <div className="behandeling-price">
                        <p>{price_title_4}</p>
                        <p>
                          <span>{price_4}</span>
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Prijslijst;
